import * as React from 'react';
import {
    CREATE_CHANNEL,
    GET_TABLE_OVERVIEW_DATA,
    RE_UPLOAD_FILE,
    RETRY_STEP,
    UPLOAD_FILE,
    GET_CHANNELS_OVERVIEW_DATA,
} from '../queries.ts';
import DocumentOverview from '../../../document/pages/Overview';
import * as constants from '../constants.ts';
import { DocumentType } from '../../../document/constants.ts';
import ExternalStatusFilter from '../components/ExternalStatusFilter.tsx';

const Overview = (props) => {
    const documentConfiguration = {
        documentType: DocumentType.PropertyBill,
        documentTypeName: 'propertyBill',
        activeTab: 'property-bill',
        constants: constants,
        CREATE_CHANNEL: CREATE_CHANNEL,
        GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
        GET_TABLE_OVERVIEW_DATA: GET_TABLE_OVERVIEW_DATA,
        RETRY_STEP: RETRY_STEP,
        UPLOAD_FILE: UPLOAD_FILE,
        RE_UPLOAD_FILE: RE_UPLOAD_FILE,
        renderExtraFilters: ({ filters, onFiltersChange }) => (
            <>
                <ExternalStatusFilter filters={filters} onFiltersChange={onFiltersChange} />
            </>
        ),
    };

    return <DocumentOverview documentConfiguration={documentConfiguration} {...props} />;
};

export default Overview;
